<template>
  <div class="profile--membership" :style="membershipStyle" v-if="user && user.membership">
    <div class="membership--accent"></div>
    <div class="membership--info">
      <div class="membership--copy">
        <div class="membership--name">{{ membershipType }}</div>
        <div class="membership--expired">
          <span>{{ `${$t('general.endAt')} ` }}</span>
          <span>{{ $date.format(user.membership.expired_at, 'dd MMM yyyy') }}</span>
        </div>
      </div>
    </div>
  </div>
  <router-link
    to="/product"
    class="profile--membership"
    :style="membershipStyle"
    style="text-decoration: none"
    v-else
  >
    <div class="membership--accent"></div>
    <div class="membership--info" @click="onClick">
      <div class="membership--copy">
        <div class="membership--name">{{ $t('general.noMembership') }}</div>
        <div class="membership--expired">
          {{ $t('general.buyMembershipNow') }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {},
  props: [],
  computed: {
    ...mapState({
      user: (state) => state.global.user,
    }),
    ...mapGetters({
      membershipType: 'global/membershipType',
    }),
    membershipPalette() {
      const palettes = {
        PRO: {
          background: '#F5C04D',
          color: '#000000',
          shadow: 'rgba(245, 192, 77, 0.34)',
        },
        EXECUTIVE: {
          background: '#3B3A38',
          color: '#FFFFFF',
          shadow: 'rgba(59, 58, 56, 0.28)',
        },
        STARTER: {
          background: '#5B5C5C',
          color: '#FFFFFF',
          shadow: 'rgba(91, 92, 92, 0.28)',
        },
        LITE: {
          background: '#F92E0B',
          color: '#FFFFFF',
          shadow: 'rgba(249, 46, 11, 0.3)',
        },
      };

      return palettes[this.membershipType] || palettes.LITE;
    },
    membershipStyle() {
      return {
        background: this.membershipPalette.background,
        color: this.membershipPalette.color,
        boxShadow: `0 8px 20px ${this.membershipPalette.shadow}`,
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';
.profile--membership {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  min-height: 42px;
  padding: 6px 8px 6px 12px;
  border-radius: 8px;
  line-height: 1.2;
  isolation: isolate;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background: linear-gradient(115deg, rgba(255, 255, 255, 0.22), transparent 42%);
    pointer-events: none;
  }

  .membership--accent {
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 999px;
    background: currentColor;
    opacity: 0.55;
  }

  .membership--info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .membership--copy {
    min-width: 0;
  }

  .membership--name {
    font-family: Poppins-Bold, sans-serif;
    color: currentColor;
    font-size: 13px;
    line-height: 1.05;
    letter-spacing: 0;
  }

  .membership--logo-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    background: #ffffff;
    border-radius: 999px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .membership--logo {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .membership--expired {
    margin-top: 3px;
    color: currentColor;
    font-family: Poppins-Medium, sans-serif;
    font-size: 10.5px;
    line-height: 1.05;
    opacity: 0.78;
    white-space: nowrap;
  }
}
</style>
